// src/components/AboutUs.js

import React from 'react';
import shape4 from '../images/shape4.png'; // Ensure correct path

const AboutUsHome = () => {
  const features = [
    {
      icon: 'icon-flag',
      title: 'Winter Wonders: Hurda Parties and Bonfire Delights',
      description: 'During the chilly winter season, Morachi Chincholi comes alive with festive hurda parties...',
    },
    {
      icon: 'icon-location-pin',
      title: 'Rural Rides: Tractor and Bullock Cart Expeditions',
      description: 'Experience the charm of rural life with farm rides on tractors or bullock carts, offering a unique opportunity to explore...',
    },
    {
      icon: 'icon-directions',
      title: 'Seasonal Delights: Fruitful Voyage at Morachi Chincholi',
      description: 'Indulge in a delightful culinary journey with Morachi Chincholi"s seasonal fruits...',
    },
    {
      icon: 'icon-compass',
      title: 'Fun in the Sun: Open Space for Outdoor Games',
      description: 'Morachi Chincholi boasts ample open spaces, perfect for engaging in a variety of outdoor games...',
    },
  ];

  return (
    <section
      className="about-us pb-6 pt-10"
      style={{
        backgroundImage: `url(${shape4})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="container">
        <div className="mb-6 w-5 mx-auto text-center">
          <h4 className="mb-1 theme1">Core Features</h4>
          <h2 className="mb-1">
            Discover the Weekend at <span className="theme">Morachi Chincholi</span>
          </h2>
          <p>
            Morachi Chincholi offers a delightful weekend experience rooted in rural charm, with engaging activities, traditional foods, and serene nature to refresh your spirit.
          </p>
        </div>

        {/* Why Us section starts */}
        <div className="why-us">
          <div className="why-us-box">
            <div className="row">
              {features.map((item, index) => (
                <div className="col-lg-3 col-md-6 col-sm-6 mb-4" key={index}>
                  <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                    <div className="why-us-content">
                      <div className="why-us-icon mb-1">
                        <i className={`${item.icon} theme`}></i>
                      </div>
                      <h4>
                        <a href="/about">{item.title}</a>
                      </h4>
                      <p className="mb-2">{item.description}</p>
                      {/* <p className="mb-0 theme">100+ Reviews</p> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Why Us section ends */}
      </div>
      <div className="white-overlay"></div>
    </section>
  );
};

export default AboutUsHome;
